<app-header></app-header>
<mat-sidenav-container class="container">
    <mat-sidenav-content class="body-content">
        <div class="main-body">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
